// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"dd41720a","79":"e6fd8442","453":"ee671459","511":"9e30d69d","606":"ddc7dfa1","746":"97d5c143","886":"61732fd1","929":"9365e290","992":"1ef81c50"}[chunkId] + ".chunk.js";
};